module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "id": "pXV"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "pXV"
    }
  }, [_c('p', {
    staticClass: "ct1"
  }, [_vm._v("Did Someone Say ‘Climate Change’?")])]), _c('p', {
    staticClass: "ftxt"
  }, [_c('a', {
    attrs: {
      "id": "pXV"
    }
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("LIMATE CHANGE HAS ALMOST EXTINGUISHED LIFE ON EARTH ON THREE")]), _vm._v(" occasions. Some 250 million years ago, a series of massive volcanic eruptions in Siberia caused rapid changes in the earth's atmosphere that wiped out 90 per cent of its species. Next, 65 million years ago, an asteroid struck what is now Mexico and created another atmospheric catastrophe that eliminated 50 per cent of the earth's species (including the dinosaurs). Finally, some 73,000 years ago, the volcanic eruption of Mount Toba in Indonesia caused a ‘winter’ that lasted several years and apparently killed off most of the human population."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-1",
      "id": "nr-pro-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("No subsequent environmental disaster has had a global impact on this scale, but several other episodes of climate change have caused widespread destruction and dislocation. About 13,000 years ago, the northern hemisphere experienced an episode of global cooling (probably after a comet collided with the earth), which wiped out most animal life. About 4,000 years ago, societies in south and west Asia collapsed amid general drought; while between "), _c('span', {
    staticClass: "fsc"
  }, [_vm._v("AD")]), _vm._v(" 750 and 900 drought on both sides of the Pacific fatally weakened the Tang empire in China and the Maya culture in central America."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-2",
      "id": "nr-pro-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Then, in the mid-fourteenth century, a combination of violent climatic oscillations and major epidemics halved Europe's population and caused severe depopulation and disruption in much of Asia."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-3",
      "id": "nr-pro-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Finally, in the mid-seventeenth century, the earth experienced some of the coldest weather recorded in over a millennium. Perhaps one-third of the human population died.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Although climate change can and does produce human catastrophe, few historians include the weather in their analyses. Even in his pioneering 1967 study, "), _c('i', [_vm._v("Times of feast, times of famine: a history of climate since the year 1000")]), _vm._v(", Emanuel Le Roy Ladurie averred that ‘In the long term, the human consequences of climate seem to be slight, perhaps negligible’. By way of example, he stated that ‘it would be quite absurd’ to try and ‘explain’ the French rebellion between 1648 and 1653 known as the Fronde ‘by the adverse meteorological conditions of the 1640s’. A few years later Jan de Vries, a distinguished economic historian, likewise argued that ‘Short-term climatic crises stand in relation to economic history as bank robberies to the history of banking’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-4",
      "id": "nr-pro-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Historians are not alone in denying a link between climate and catastrophe. Richard Fortey, a noted palaeontologist, has observed that ‘There is a kind of optimism built into our species that seems to prefer to live in the comfortable "), _c('a', {
    attrs: {
      "id": "pXVI"
    }
  }, [_vm._v("present rather than confront the possibility of destruction’, with the result that ‘Human beings are never prepared for natural disasters’."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-5",
      "id": "nr-pro-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" Extreme climatic events therefore continue to take us by surprise, even if they cause massive damage. In 2003 a summer heatwave that lasted just two weeks led to the premature death of 70,000 people in Europe; while in 2005 Hurricane Katrina killed over 2,000 people and destroyed property worth over $81 billion in an area of the United States equivalent in size to Great Britain. In the course of 2011 over 106 million people around the world were adversely affected by floods; almost 60 million by drought; and almost 40 million by storms. Yet although we know that the climate caused these and many other catastrophes in the past, and although we also know that it will cause many more in the future, we still convince ourselves that they will not happen just yet (or, at least, not to us)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-6",
      "id": "nr-pro-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Currently, most attempts to predict the consequences of climate change extrapolate from recent trends; but another methodology exists. Instead of hitting ‘fast forward’, we can ‘rewind the tape of History’ and study the genesis, impact and consequences of past catastrophes, using two distinct categories of proxy data: a ‘natural archive’ and a ‘human archive’.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The ‘natural archive’ comprises four groups of sources:")]), _vm._v(" "), _c('div', {
    staticClass: "bl"
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Ice cores and glaciology")]), _vm._v(": the annual deposits on ice caps and glaciers around the world, captured in deep boreholes, provide evidence of changing levels of volcanic emissions, precipitation, air temperature and atmospheric composition."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-7",
      "id": "nr-pro-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Palynology")]), _vm._v(": pollen and spores deposited in lakes, bogs and estuaries capture the natural vegetation at the time of deposit."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-8",
      "id": "nr-pro-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Dendrochronology")]), _vm._v(": the size of growth rings laid down by certain trees during each growing season reflects local conditions in spring and summer. A thick ring indicates a year favourable to growth, whereas a narrow ring reflects a year of adversity."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-9",
      "id": "nr-pro-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Speleothems")]), _vm._v(": the annual deposits formed from groundwater trickling into underground caverns, especially in the form of stalactites, can serve as a climate proxy."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-10",
      "id": "nr-pro-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("The ‘human archive’ on climate change comprises five groups of sources:")]), _vm._v(" "), _c('div', {
    staticClass: "bl"
  }, [_c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Narrative")]), _vm._v(" information contained in oral traditions and written texts (chronicles and histories, letters and diaries, judicial and government records, ships’ logs, newspapers and broadsheets).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Numerical")]), _vm._v(" information extracted from documents (such as fluctuations in the date when harvesting certain crops began each year, in food prices, in sunspots observed, or in the number of men paid each spring to steer the detritus that swept down rivers along with snowmelt); and from narrative reports (‘Rain fell for the first time in 42 days’).")]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_vm._v("• "), _c('i', [_vm._v("Pictorial")]), _vm._v(" representations of natural phenomena (paintings or engravings that show the position of a glacier's tongue in a given year, or that depict ice floes in a harbour during a winter of unusual severity)."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-11",
      "id": "nr-pro-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "pXVII"
    }
  }, [_vm._v("• "), _c('i', [_vm._v("Epigraphic")]), _vm._v(" or "), _c('i', [_vm._v("archaeological")]), _vm._v(" information, such as inscriptions on structures that date flood levels, or excavations of settlements abandoned because of climate change.")])]), _c('a', {
    attrs: {
      "id": "pXVII"
    }
  }), _c('p', {
    staticClass: "bl"
  }, [_c('a', {
    attrs: {
      "id": "pXVII"
    }
  }, [_vm._v("• "), _c('i', [_vm._v("Instrumental data.")]), _vm._v(" Starting in the 1650s, in Europe, some observers regularly recorded weather data, including precipitation, wind direction and temperatures."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-12",
      "id": "nr-pro-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The failure of most historians to exploit the data available in these two ‘archives’ for the seventeenth century is particularly regrettable, because an intense episode of global cooling coincided with an unparalleled spate of revolutions and state breakdowns around the world (including Ming China, the Polish–Lithuanian Commonwealth and the Spanish Monarchy), while other states came close to revolution (notably, the Russian and Ottoman empires in 1648; and the Mughal empire, Sweden, Denmark and the Dutch Republic in the 1650s) ("), _c('a', {
    attrs: {
      "href": "#/#fig_01"
    }
  }, [_vm._v("Fig. 1")]), _vm._v("). In addition, Europe saw only three years of complete peace during the entire seventeenth century, while the Ottoman empire enjoyed only ten. The Chinese and Mughal empires fought wars almost continuously. Throughout the northern hemisphere, war became the norm for resolving both domestic and international problems.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Historians have christened this age of turmoil ‘The General Crisis’, and some have seen it as the gateway to the modern world. The term was popularized by Hugh Trevor-Roper in an influential essay, first published in 1959, which argued that")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "fext"
  }, [_vm._v("The seventeenth century did not absorb its revolutions. It is not continuous. It is broken in the middle, irreparably broken, and at the end of it, after the revolutions, men can hardly recognize the beginning. Intellectually, politically, morally, we are in a new age, a new climate. It is as if a series of rainstorms has ended in one final thunderstorm which has cleared the air and changed, permanently, the temperature of Europe. From the end of the fifteenth century until the middle of the seventeenth century we have one climate, the climate of the Renaissance; then, in the middle of the seventeenth century, we have the years of change, the years of revolution; and thereafter, for another century and a half, we have another, very different climate, the climate of the Enlightenment."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-13",
      "id": "nr-pro-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ftxt"
  }, [_vm._v("But of ‘climate’ in its literal sense Trevor-Roper said not a word, even though the upheavals he described occurred during a period marked by global cooling and extreme weather events.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("The climatic evidence is both clear and consistent. Daily readings from an international network of observation stations reveal that winters between 1654 and 1667 were, on average, more than 1ˆC cooler than those of the later twentieth century."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-14",
      "id": "nr-pro-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Other records show that 1641 saw the third coldest summer recorded over the past six centuries in the northern hemisphere; the second coldest winter in a century experienced in New England; and the coldest winter "), _c('i', [_vm._v("ever")]), _vm._v(" recorded in Scandinavia. The summer of 1642 was the 28th coldest, and that of 1643 the 10th coldest, recorded in the northern hemisphere over the past six centuries; while the winter of 1649–50 seems to have been the coldest on record in both northern and eastern China. Abnormal climatic conditions lasted from the 1640s until the 1690s – the longest as well as the most severe episode of global cooling recorded in the entire Holocene Era – leading climatologists to dub this period ‘The Little Ice Age’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-15",
      "id": "nr-pro-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pXVIII"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/map_01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pXVIII"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "pXVIII"
    }
  }), _c('a', {
    attrs: {
      "id": "pXIX"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Algeria",
      "src": "images/fig_01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pXIX"
    }
  }), _c('p', {
    staticClass: "caption"
  }, [_c('a', {
    attrs: {
      "id": "pXIX"
    }
  }), _c('a', {
    attrs: {
      "id": "fig_01"
    }
  }, [_vm._v("1. The Global Crisis."), _c('br'), _vm._v("Although Europe and East Asia formed the heartland of the ‘General Crisis’, the Mughal and Ottoman empires, like the European colonies in America, also experienced episodes of severe political disruption in the mid-seventeenth century.")])]), _c('a', {
    attrs: {
      "id": "fig_01"
    }
  }), _c('p', {
    staticClass: "txt"
  }, [_c('a', {
    attrs: {
      "id": "fig_01"
    }
  }, [_vm._v("This volume seeks to link the climatologists’ Little Ice Age with the historians’ General Crisis – and to do so without ‘painting bull's eyes around bullet holes’: without arguing that global cooling ‘must’ have somehow caused recession and revolution around the world simply because climate change is the only plausible common denominator. Le Roy Ladurie was absolutely correct to insist in 1967 that ‘The historian of seventeenth-century climate’ must ‘be able to apply a quantitative method comparable in rigour if not in accuracy and variety to the methods used by present-day meteorologists in the study of twentieth-century climate’, and he regretted that this goal was then unattainable."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-16",
      "id": "nr-pro-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" The sources now available, however, allow historians to integrate climate change with political, economic and social change with unprecedented precision. Accounts of climatic conditions in Africa, Asia, Europe and the Americas in the mid-seventeenth century abound, while millions of measurements of tree-rings, ice-cores, pollen deposits and stalactite formations are available."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-17",
      "id": "nr-pro-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Nevertheless, the new data, however abundant and however striking, must not turn us into climatic determinists. As early as 1627, Joseph Mede, a polymath with a special interest in astronomy and eschatology who taught at Christ's College, "), _c('a', {
    attrs: {
      "id": "pXX"
    }
  }, [_vm._v("Cambridge, pointed out a methodological pitfall: any increase in observations may simply reflect an increase in the number of observers. Thus when he heard almost simultaneously about an earthquake near Glastonbury and ‘another prodigie from Boston [Lincolnshire] of fire from heaven’, Mede observed sagely: ‘Either we have more strange accidents than was wont, or we take more notice of them, or both.’ Subsequent research has corroborated Mede's surmise. For example, while modern astronomy has confirmed that the seventeenth century indeed witnessed an unusual frequency of comets, humans took ‘more notice of them’ – both because the proliferation of telescopes enabled more of them to be seen from earth, and because dramatic improvements in gathering and disseminating news meant that every sighting soon became known to more people."), _c('sup', {
    staticClass: "endnote"
  })]), _c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-18",
      "id": "nr-pro-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("A second obstacle to the accurate assessment of climatic data by historians is the role of infrastructure and contingency. On the one hand, the deleterious consequences of colder or wetter weather may be mitigated if a community has either a well-stocked granary or access to food imported through a neighbouring port. On the other hand, war may create famine even in a year of bountiful harvest by destroying or disrupting the food supply on which a community depends. In the aphorism of Andrew Appleby: ‘the crucial variable’ was often ‘not the weather but the ability to adapt to the weather’."), _c('sup', {
    staticClass: "endnote"
  }, [_c('span', {
    attrs: {
      "href": "#/045Notes#en-pro-19",
      "id": "nr-pro-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" This volume therefore examines not only the impact of climate change and extreme climate events on human societies during the seventeenth century, but also the various adaptive strategies taken to survive the worst climate-induced catastrophe of the last millennium.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7f2cff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009Prologue_Did_Someone_Say_x2018Climate_Changex0027.vue
// module id = 78
// module chunks = 0